<template>
  <div :class="showFilter ? 'grid' : '' ">
    <catalog-filter-container no-drawer />
    <catalog-product-list-container
      scrollable
      hide-filter-chips
      :display-title="false"
      caller="catalog-product-selector"
    />
  </div>
</template>

<script>
import CatalogProductListContainer from '@/components/Widgets/Catalog/CatalogProductListContainer';
import CatalogFilterContainer from '@/components/Widgets/Catalog/CatalogFilterContainer';
import { EventBus } from '@/event-bus';

export default {
  name: 'CatalogProductSelector',
  components: {
    CatalogProductListContainer,
    CatalogFilterContainer,
  },
  data() {
    return {
      showFilter: '',
    };
  },
  created() {
    EventBus.$on('showFilter', (val) => {
      this.showFilter = val;
    });
  },
  // mounted() {
  //   // console.log('CatalogProductSelector mounted');
  //   this.$store.dispatch('catalog/clearSelectedProducs');
  // },
};
</script>

<style lang="scss" scoped>
.grid {
  // height: 495px;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px 1fr;
}
// .left-col{
//     margin-top: 60px;
//     display: none;

//     @media (min-width: map-get($breakpoints,'lg')) {
//         display: block;
//     }
// }
</style>
